module.exports = __webpack_public_path__ + "static/media/Group.0511df7e.svg";